var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href ? 'a' : 'button',{tag:"component",class:_vm.modularizedClasses,attrs:{"href":_vm.href,"type":!_vm.href && _vm.type,"disabled":!_vm.href && _vm.disabled},on:{"click":_vm.emitClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }